import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { AlertPopup } from "./../../AlertPopup";
import Backdrop from './../../../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import { genURL } from './../../../_getjson.js';

require('./../../../_css/PopUpOther.css');
const Codeap = "CSAP/APCode?apcode=";
const Nameap = "CSAP/APName?apname=";
export default class Popup extends React.Component {

    constructor(props) {
        super(props)
        this.Name = React.createRef();
        this.state = {
            selected: "0",
            openBackdrop: false
        }
    }

    componentDidMount() {
        this.getSearch("")
    }
    onKeyUp = (e) => {
        if (e.key === 'Enter') {
            var txt = e.target.value;
            this.getSearch(txt);
        }
    }
    onClickSearch = () => {
        var txt = this.Name.current.value;
        this.getSearch(txt);
    }
    getSearch = async (data1) => {
        this.setState({ openBackdrop: true })
        var urlmain;
        if (this.state.selected === "0") {
            urlmain = Codeap;
        } else {
            urlmain = Nameap;
        }
        var url = urlmain + data1 + "&user=" + sessionStorage.getItem("Username");
        let dataArray = [];
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
            for (let i = 0; i < res.data.length; i++) {
                if (res.data.length !== 0) {
                    dataArray[i] = {
                        number: i + 1,
                        code: res.data[i].CODE,
                        name: res.data[i].APNAME,
                        Address: res.data[i].ADDRESSTH,
                        Contact: res.data[i].NAMETH,
                        Phone: res.data[i].TELEPHONE,
                        CREDITCODE: res.data[i].CREDITCODE,
                        TAXTYPE: res.data[i].TAXTYPE,
                    }
                } else {
                    AlertPopup("Warning", "ไม่พบข้อมูล ");
                    this.setState({ openBackdrop: false })
                    return;
                }
            }
        }).then(async _ => {
            this.setState({ col: dataArray });
            this.setState({ openBackdrop: false })
        }).catch(error => {
            this.setState({ openBackdrop: false })
            console.log(error);
        });
    }

    onSelectRow = (data) => {
        let data0 = data.code + '|' + data.name + '|' + data.CREDITCODE + '|' + data.TAXTYPE
        let resdata = []
        resdata.push(false)
        resdata.push(data0)
        this.props.resdata(resdata)
    }

    render() {
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"> <i className="fas fa-search" > ค้นหาเจ้าหนี้ </i> </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="DivTable">
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === "0"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === "1"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                                </div>
                            </div>
                            <div className="input-group width-grop">
                                <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.onKeyUp} ref={this.Name} />
                                <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
                            </div>
                            <BootstrapTable
                                data={this.state.col}
                                height="700"
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noData: "...."
                                }}
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnID" expandable={true} dataAlign="center" width="35" dataField='number' dataSort></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='code' isKey dataSort width="150">รหัสเจ้าหนี้</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='name' columnTitle/* dataSort */ width="340">ชื่อเจ้าหนี้</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Address' columnTitle /* dataSort */ width="400">ที่อยู่</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Phone' /* dataSort */ width="140" columnTitle> โทรศัพท์</TableHeaderColumn>
                            </BootstrapTable>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}